module.exports = __webpack_public_path__ + "img/logo-white.9dc0b45b.svg";